export default {
  h1_edu: "Educational courses for diagnostic doctors",
  Lessons: {
    Lesson: {
      title: "Lesson",
      Files: "Applications",
      DownloadAll: "Download all",
    },
    status: {
      success: "Completed",
      unsuccess: "Not Completed",
      stop: "Unavailable",
    },
  },
};
